export default {"src":"/_next/static/media/map.b2d033ea.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};